import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { StyledForm, StyledInput, SubmitButton, ErrorMessage, StyledImage, StyledComment, SuccessMessage, SuccessMessageWrapper } from '../styled';
import { BASE_URL } from '../../../environment/environment';
import logo from '../../../images/logo.png';
import { CheckCircle } from 'lucide-react';

export const ForgotPasswordForm = ({ email }) => {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const navigate = useNavigate();

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    setSuccessMessage('');

    try {
      const response = await axios.post(`${BASE_URL}/Auth/forgot-password`, { email }, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (response.status === 200) {
        setSuccessMessage('Link został przesłany, użyj go do zresetowania hasła, tymczasem zostaniesz przekierowany na stronę główną.');
        setTimeout(() => {
          navigate('/');
        }, 3000);
      } else {
        setError(response.data.message || 'Błąd podczas wysyłania linku resetującego');
      }
    } catch (error) {
      setError(error.response?.data?.message || 'Błąd połączenia z serwerem');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {successMessage ? (
        <SuccessMessageWrapper>
          <CheckCircle size={30} />
          <SuccessMessage>{successMessage}</SuccessMessage>
        </SuccessMessageWrapper>
      ) : (
        <StyledForm onSubmit={handleForgotPassword}>
          <StyledImage src={logo} alt="Logo" />
          <StyledComment>Potwierdź wysłanie linku resetującego hasło na podany adres e-mail:</StyledComment>
          <StyledInput
            type="email"
            placeholder="E-mail"
            value={email}
            required
            disabled
          />
          {error && <ErrorMessage>{error}</ErrorMessage>}
          <SubmitButton type="submit" disabled={loading || !email}>
            {loading ? 'Wysyłanie...' : 'Wyślij link resetujący'}
          </SubmitButton>
        </StyledForm>
      )}
    </>
  );
};
